let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1xmlT")).then(() => parcelRequire('eJKC4'));